import { CSSObject } from '@emotion/react';
import { createCustomIcon } from './utils/createCustomIcon';

const SIDEBAR_TOGGLE = {
  className: 'sidebar-toggle',
  panelClassName: 'sidebar-toggle-panel',
  collapsedPanelWidth: 3,
};

interface SidebarToggleStylesParams {
  duration: number;
  easing: string;
  isMirrored?: boolean;
}

export const getSidebarToggleStyles = ({
  duration,
  easing,
  isMirrored,
}: SidebarToggleStylesParams): CSSObject => ({
  ...(isMirrored && {
    [`& .${SIDEBAR_TOGGLE.className}`]: { transform: 'scaleX(-1)', transformOrigin: 'center' },
  }),
  [`& .${SIDEBAR_TOGGLE.panelClassName}`]: { transition: `width ${duration}ms ${easing}` },
  [`&[aria-expanded="false"] .${SIDEBAR_TOGGLE.panelClassName}`]: {
    width: SIDEBAR_TOGGLE.collapsedPanelWidth,
  },
});

const SidebarToggleIcon = createCustomIcon({
  displayName: 'SidebarToggleIcon',
  defaultFill: 'currentColor',
  children: (
    <g className={SIDEBAR_TOGGLE.className}>
      <rect
        x="2.75"
        y="3.75"
        width="18.5"
        height="16.5"
        rx="3.25"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
      />
      <rect className={SIDEBAR_TOGGLE.panelClassName} x="5.5" y="6" width="8" height="12" rx="1" />
    </g>
  ),
});

export default SidebarToggleIcon;
